module.exports = __webpack_public_path__ + "static/img/8_1.48c54418.jpg";